import React from 'react';

import typ from './index.d';
import {
  AttachmentActions,
  AttachmentArea,
  AttachmentName,
  AttachmentItem,
  Box,
  CloseIcon,
  Container,
  Description,
  LoadingIndicator,
  LoadRow,
  SendIcon,
  Title,
  TitleArea,
  WarnEmpty,  
  ArrowIconRight,
  ArrowIconLeft,
  NavigationRow,
} from './styled';
import { AttachmentCRUD } from 'services/requests/attachment';
import { toast } from 'react-toastify';
import { MatchCRUD } from 'services/requests/matchs';
import Load from 'components/load';
import { theme } from 'global/styles';

const matchCRUD = new MatchCRUD();
const attachmentCrud = new AttachmentCRUD()

const SendPdfModal: React.FC<typ.Props> = ({
  match,
  type,
  onClose,
  onSend
}) => {
  // Ref
  const currentPage = React.useRef(1);

  const [attachments, setAttachments] = React.useState<typ.attachment>();
  const [loading, setLoading] = React.useState({
    getAttachs: false,
    send: false,
  });

  // Callbacks
  const getAttachments = React.useCallback(async ({ page } : typ.getFunction) => {
    try {
      if(!match?.personal_client_relation.id) throw new Error('Não foi possivel carregar selecionar o cliente. (1)');
      if(loading.getAttachs) throw new Error('Aguarde, os currículos estão carregando. (1)');

      currentPage.current = page || 1;
      setLoading(e => ({...e, getAttachs: true}))
      
      const { data, status } = await attachmentCrud.read({ type: type, id: match?.personal_client_relation.id, page })

      if(status === 200 && data) {
        setAttachments(data)
        return;
      }

      throw new Error('Não foi possivel carregar os currículos')
    } catch (e) {
      const { message } = e as Error
      toast.error(message)
    } finally {
      setLoading(e => ({...e, getAttachs: false}))
    }
  }, [loading.getAttachs])

  // Update
  const handleUpdate = React.useCallback(async (id: number) => {
    try {
      if(!id) throw new Error('Não foi possivel carregar selecionar o cliente. (1)');
      if(loading.send) throw new Error('Aguarde, o currículo está sendo enviado (1)');
      
      setLoading(e => ({...e, send: true}))

      const { data, status, error } = await matchCRUD.update({
        vacancy_id: Number(match?.vacancy_id),
        advisor_id: Number(match?.advisor_relation.id),
        personal_client_id: Number(match?.personal_client_relation.id),
        authorized: true,
        match_id: Number(match?.id),
        attachment_id: id
      });

      if (error) {
        throw new Error(error.message.description);
      }

      if (status === 200 && data) {
        onSend?.()
        toast(`O match foi aceito!`);
      }
    } catch (e) {
      const { message } = e as Error
      toast.error(message)
    } finally {
      setLoading(e => ({...e, send: false}))
    }
  }, [loading.send]);

  // Effect
  React.useEffect(() => {
    getAttachments({})
  }, [])

  return (
    <Container>
      <Box>
        <TitleArea>
          <Title>Selecione o currículo</Title>
          <CloseIcon onClick={() => {
            if(loading.send) {
              toast.error('Aguarde, um envio está sendo feito!');
              return;
            }
            onClose?.()
          }}/>
        </TitleArea>
        <Description>Veja qual currículo você quer enviar</Description>
          { loading.getAttachs ? (
            <LoadRow>
              <LoadingIndicator />
            </LoadRow>
          ) : (
            <>
              { attachments?.Attachment.length ? (
                <AttachmentArea>
                  {attachments.Attachment.map((e, i) => (
                    <AttachmentItem>
                      <AttachmentName>{e.name}</AttachmentName>
                      <AttachmentActions>
                        { loading.send ? (
                          <Load size='small' customStyle={{color: theme.colors.primary, marginBottom: 10, marginLeft: -10} }/>
                        ): (
                          <SendIcon onClick={() => handleUpdate(e.id)}/> 
                        )}
                      </AttachmentActions>
                    </AttachmentItem>
                  ))}
                  <NavigationRow>
                    <ArrowIconLeft  disabled={!attachments.has_prev} onClick={() => {
                      if(!attachments.has_prev) return;
                      getAttachments({page: currentPage.current - 1})
                    }}/>
                    <ArrowIconRight disabled={!attachments.has_next} onClick={() => {
                      if(!attachments.has_next) return;
                      getAttachments({page: currentPage.current + 1})
                    }}/>
                  </NavigationRow>
                </AttachmentArea>
              ) : (
                <WarnEmpty>Nenhum currículo encontrado</WarnEmpty>
              )}
            </>
          )}     
      </Box>
    </Container>
  );
};

export default SendPdfModal;
